module.exports = __webpack_public_path__ + "img/tips-food-icon.234dd2e3.svg";